import React, { Key } from 'react';
import styled from 'styled-components/native';

import { memo } from '@webtrader/core/constants/react';
import dynamicSize from '@webtrader/core/dynamic-size';

import OptionSelector, { IBaseActionSheetOption } from './Selector';

interface IProps<T> {
  value?: T;
  options?: IBaseActionSheetOption<T>[];
  justifyCenter?: boolean;
  onSelect: (value: T) => void;
}

const ActionSheetAnimatedView = <T extends Key | null | undefined>(props: IProps<T>) => {
  const { value, options, justifyCenter, onSelect } = props;

  return (
    <SheetOptions>
      {options?.map((option) => {
        return (
          <OptionSelector
            value={value}
            key={option.value}
            option={option}
            onSelect={onSelect}
            justifyCenter={justifyCenter}
            testID={option.testID}
          />
        );
      })}
    </SheetOptions>
  );
};

export default memo(ActionSheetAnimatedView);

const SheetOptions = styled.View`
  padding-top: ${dynamicSize.convertSize(10)}px;
`;
